import { locations, phoneToCall } from '../../utils/variables';

export function loadLocationList(el = null, isCall = false) {
    let list = el ? el : document.querySelector('.locations__container .locations__list');
    let locationsList = ``;

    for (const location of locations) {
        locationsList = locationsList.concat(`
        ${isCall ? `
                <a class="call-location location" href="tel:${location?.phone || phoneToCall}" ${isCall ? `data-id="${location?.id || ""}"` : `data-location-id="${location.id}"`} target="_blank">
                    ${renderLocationItem(location)}
                </a>
            `: `
                <div class="call-location location" ${isCall ? `data-id="${location?.id || ""}"` : `data-location-id="${location.id}"`}>
                    ${renderLocationItem(location)}
                </div>
            `
            }
        `);
    }

    list.innerHTML = locationsList;

    const listContainer = list.closest('.callus_container, .locations__container');
    if (listContainer && locations.length > 4) {
        listContainer.classList.add('has-many-locations');
    }

    feather.replace();
}

const renderLocationItem = (location) => {
    return `
            <span class="location-icon">
                <i data-feather="map-pin"></i>
            </span>
            <div class="location-info">
                <span class="title">${location?.name || ""}</span>
            </div>
    `;
};